"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _UINumberInput = _interopRequireDefault(require("./UINumberInput"));

var _UICurrencyInput = _interopRequireDefault(require("./UICurrencyInput"));

var _UIButtonGroup = _interopRequireDefault(require("../button/UIButtonGroup"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _colors = require("HubStyleTokens/colors");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Functions = require("../core/Functions");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Dom = require("../utils/Dom");

var _DomEvents = require("../utils/DomEvents");

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var isIncrementDisabled = function isIncrementDisabled(stepSize, value, max, disabled) {
  if (disabled) return true;
  if (max == null) return false;
  return !(value + stepSize <= max);
};

var isDecrementDisabled = function isDecrementDisabled(stepSize, value, min, disabled) {
  if (disabled) return true;
  if (min == null) return false;
  return !(value - stepSize >= min);
};

var UIStepperInput = _react.default.createClass({
  displayName: "UIStepperInput",
  propTypes: (0, _extends2.default)({}, _UINumberInput.default.propTypes, {
    disabledMaxButtonTooltip: _react.PropTypes.node,
    disabledMinButtonTooltip: _react.PropTypes.node,
    value: _react.PropTypes.number,
    stepSize: _react.PropTypes.number,
    onChange: _react.PropTypes.func.isRequired,
    onStep: _react.PropTypes.func,
    inputClassName: _react.PropTypes.string
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UINumberInput.default.defaultProps, {
      stepSize: 1
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._repeatHandle != null) {
      this._repeatHandle.stop();
    }
  },
  handleStep: function handleStep(step) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        inputRef = _this$props.inputRef,
        max = _this$props.max,
        min = _this$props.min,
        onChange = _this$props.onChange,
        onStep = _this$props.onStep,
        readOnly = _this$props.readOnly,
        value = _this$props.value;
    if (readOnly || disabled) return;
    if (inputRef.current) inputRef.current.focus();
    var newValue = (value || 0) + step;
    var fencedMin = min == null ? newValue : Math.max(newValue, min);
    var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max);
    onChange((0, _SyntheticEvent.default)(fencedValue));
    (0, _Functions.callIfPossible)(onStep, (0, _SyntheticEvent.default)(fencedValue));
  },
  increment: function increment() {
    if (this._freeze) return;
    var stepSize = this.props.stepSize;
    this.handleStep(stepSize);
  },
  decrement: function decrement() {
    if (this._freeze) return;
    var stepSize = this.props.stepSize;
    this.handleStep(-stepSize);
  },
  handleUpArrowMouseDown: function handleUpArrowMouseDown(evt) {
    if ((0, _DomEvents.isLeftClick)(evt)) {
      this.startMouseHold('increment');
    }
  },
  handleDownArrowMouseDown: function handleDownArrowMouseDown(evt) {
    if ((0, _DomEvents.isLeftClick)(evt)) {
      this.startMouseHold('decrement');
    }
  },
  handleArrowMouseUp: function handleArrowMouseUp() {
    this.stopMouseHold();
  },
  startMouseHold: function startMouseHold(action) {
    this._repeatHandle = (0, _Dom.repeatUntilEventOnElement)(this[action], 100, document.documentElement, ['mouseup']);
  },
  stopMouseHold: function stopMouseHold() {
    var _this = this;

    // Prevent click event from triggering an extra increment/decrement after click-and-hold
    if (this._repeatHandle && this._repeatHandle.count >= 1) {
      this._freeze = true;
      setTimeout(function () {
        _this._freeze = 0;
      }, 0);
    }

    this._repeatHandle = null;
  },
  handleKeyDown: function handleKeyDown(evt) {
    var onKeyDown = this.props.onKeyDown;
    var key = evt.key;

    if (key === 'ArrowUp') {
      evt.preventDefault();
      this.increment();
    } else if (key === 'ArrowDown') {
      evt.preventDefault();
      this.decrement();
    }

    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
  },
  render: function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        currency = _this$props2.currency,
        disabled = _this$props2.disabled,
        disabledMaxButtonTooltip = _this$props2.disabledMaxButtonTooltip,
        disabledMinButtonTooltip = _this$props2.disabledMinButtonTooltip,
        inputClassName = _this$props2.inputClassName,
        max = _this$props2.max,
        min = _this$props2.min,
        readOnly = _this$props2.readOnly,
        stepSize = _this$props2.stepSize,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "currency", "disabled", "disabledMaxButtonTooltip", "disabledMinButtonTooltip", "inputClassName", "max", "min", "readOnly", "stepSize", "value"]);
    var classes = (0, _classNames.default)('private-stepper-input', className);
    var inputClasses = (0, _classNames.default)('private-stepper-input--input', inputClassName);
    var incrementDisabled = isIncrementDisabled(stepSize, value, max, disabled);
    var decrementDisabled = isDecrementDisabled(stepSize, value, min, disabled);
    var Input = currency ? _UICurrencyInput.default : _UINumberInput.default;
    return _react.default.createElement("div", {
      className: classes
    }, _react.default.createElement(Input, (0, _extends2.default)({}, rest, {
      "aria-valuemax": max,
      "aria-valuemin": min,
      "aria-valuenow": value,
      currency: currency,
      disabled: disabled,
      className: inputClasses,
      max: max,
      min: min,
      onKeyDown: this.handleKeyDown,
      readOnly: readOnly,
      role: "spinbutton",
      value: value
    })), readOnly ? null : _react.default.createElement(_UIButtonGroup.default, {
      className: "private-stepper-input--buttons",
      orientation: "vertical"
    }, _react.default.createElement(_UITooltip.default, {
      autoPlacement: "vert",
      placement: "top left",
      title: disabledMaxButtonTooltip,
      disabled: !incrementDisabled
    }, _react.default.createElement(_UIButton.default, {
      "aria-hidden": true,
      disabled: incrementDisabled,
      onClick: this.increment,
      onMouseDown: this.handleUpArrowMouseDown,
      onMouseUp: this.handleArrowMouseUp,
      "data-action": "increment",
      use: "tertiary-light",
      size: "small",
      tabIndex: -1
    }, _react.default.createElement(_UIIcon.default, {
      name: "up",
      color: !incrementDisabled ? _colors.CALYPSO : null
    }))), _react.default.createElement(_UITooltip.default, {
      autoPlacement: "vert",
      placement: "top left",
      title: disabledMinButtonTooltip,
      disabled: !decrementDisabled
    }, _react.default.createElement(_UIButton.default, {
      "aria-hidden": true,
      disabled: decrementDisabled,
      onClick: this.decrement,
      onMouseDown: this.handleDownArrowMouseDown,
      onMouseUp: this.handleArrowMouseUp,
      "data-action": "decrement",
      use: "tertiary-light",
      tabIndex: -1,
      size: "small"
    }, _react.default.createElement(_UIIcon.default, {
      name: "down",
      color: !decrementDisabled ? _colors.CALYPSO : null
    })))));
  }
});

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UIStepperInput));

exports.default = _default;
module.exports = exports.default;